package com.tovtalk.data.analytics

/**
 * Web/JS no-op implementation of [AnalyticsClient].
 *
 * The web platform does not run the full analytics pipeline (no SQLDelight
 * driver, no server-side session tracking). This object silently drops all
 * calls and is registered by the JS Koin module in place of [AnalyticsClientImpl].
 */
object NoOpAnalyticsClient : AnalyticsClient {
    override suspend fun onVideoStarted(postId: Long, videoDurationMs: Long, startedFrom: StartedFrom) {}
    override suspend fun onVideoProgress(postId: Long, positionMs: Long, isPlaying: Boolean, soundOn: Boolean) {}
    override suspend fun onVideoPaused(postId: Long, positionMs: Long) {}
    override suspend fun onVideoResumed(postId: Long, positionMs: Long) {}
    override suspend fun onVideoSeeked(postId: Long, fromMs: Long, toMs: Long) {}
    override suspend fun onVideoLooped(postId: Long) {}
    override suspend fun onVideoEnded(postId: Long, exitReason: ExitReason) {}
    override suspend fun trackInteraction(postId: Long, type: InteractionType, payload: Map<String, String>?, positionMs: Long?) {}
    override suspend fun trackCriticalInteraction(postId: Long, type: InteractionType, payload: Map<String, String>?, positionMs: Long?) {}
    override suspend fun onAppForeground() {}
    override suspend fun onAppBackground() {}
    override suspend fun initialize() {}
    override fun setSubject(subjectKey: String) {}
    override fun setCurrentPost(postId: Long?) {}
    override fun getCurrentPost(): Long? = null
}
